import React from 'react';
import styled from 'styled-components';
import { Spinner } from '@hangar/web-components/core/Spinner';
import { Text } from '@hangar/web-components/core/Text';
import { useTranslation } from '../../hooks/i18n';

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  gap: 16px;
`;

interface I18nLoaderProps {
  children: React.ReactNode;
}

export const I18nLoader: React.FC<I18nLoaderProps> = ({ children }) => {
  const { isLoading } = useTranslation();

  if (isLoading) {
    return (
      <LoaderContainer>
        <Spinner />
        <Text variant="body-md">Loading translations...</Text>
      </LoaderContainer>
    );
  }

  return <>{children}</>;
};

export default I18nLoader;